import { Pipe, PipeTransform } from '@angular/core';
import { formatPhoneNumber } from '../../model/utility';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({
  name: 'phone',
  standalone: true
})
export class PhoneFormatterPipe implements PipeTransform {
  transform(value: any, args?: any[]) {
    return formatPhoneNumber(value);
  }
}
